export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		de: {
			inventory: {
				tabs: {
					inventory: 'Inventar',
					metadata: 'Metadaten',
					companies: 'Unternehmen',
				},
				header: {
					title: 'Inventar, Assets & Geräte',
				},
				common: {
					cancel: 'Abbrechen',
					confirm: 'Bestätigen',
					delete: 'Löschen',
					new: 'Neu',
					add: 'Hinzufügen',
					update: 'Aktualisieren',
					unknown: 'Unbekannt',
					noData: 'Keine Angaben',
				},
				list: {
					title: 'Inventarkatalog',
					badge: '{count} Elemente',
					create: 'Inventargegenstand erstellen',
					searchPlaceholder: 'Inventar durchsuchen…',
					filters: {
						status: {
							all: 'Alle Status',
						},
						project: {
							all: 'Alle Projekte',
							unassigned: 'Ohne Zuordnung',
						},
						calibration: {
							all: 'Kalibrierung · Alle',
							required: 'Kalibrierung erforderlich',
							notRequired: 'Keine Kalibrierung notwendig',
						},
					},
					reset: 'Zurücksetzen',
					table: {
						title: 'Titel',
						inventoryNumber: 'Inventarnr.',
						serial: 'Seriennr.',
						project: 'Projekt',
						status: 'Status',
						calibration: 'Kalibrierung',
						modified: 'Aktualisiert',
					},
					empty: 'Keine Inventargegenstände gefunden',
					row: {
						noTitle: 'Kein Titel',
						unassigned: 'Nicht zugewiesen',
						noStatus: 'Kein Status',
						calibration: {
							badgeRequired: 'Kalibrierung erforderlich',
							pending: 'Kalibrierung ausstehend',
							validUntil: 'Gültig bis {date}',
							notRequired: 'Nicht erforderlich',
							noCalibration: 'Keine Kalibrierung notwendig',
						},
						noInventoryNumber: '—',
						noSerial: '—',
					},
				},
				meta: {
					title: 'Metadatenkatalog',
					description: 'Status, Klassen und Lagerorte, die im Inventar verwendet werden.',
					searchPlaceholder: 'Metadaten filtern…',
					sections: {
						status: 'Status',
						class: 'Klassen',
						storageLocation: 'Lagerorte',
					},
					buttons: {
						add: 'Hinzufügen',
						edit: 'Bearbeiten',
					},
					empty: 'Noch keine Einträge',
					usage: '{count} verknüpfter Gegenstand | {count} verknüpfte Gegenstände',
					toasts: {
						entryCreated: 'Eintrag erstellt',
						entryUpdated: 'Eintrag aktualisiert',
						entryDeleted: 'Eintrag gelöscht',
						saveFailed: 'Speichern fehlgeschlagen',
						deleteFailed: 'Löschen fehlgeschlagen',
					},
				},
				metaModal: {
					title: {
						add: '{label} hinzufügen',
						edit: '{label} bearbeiten',
					},
					labels: {
						name: 'Name',
					},
					placeholders: {
						name: 'Eintragsname',
					},
					delete: {
						title: 'Eintrag löschen',
						text: 'Soll dieser Eintrag wirklich gelöscht werden?',
						button: 'Eintrag löschen',
					},
					buttons: {
						cancel: 'Abbrechen',
						add: '{label} hinzufügen',
						update: '{label} aktualisieren',
					},
					errors: {
						invalidName: 'Ein gültiger Name ist erforderlich.',
						cannotDelete: 'Eintrag kann nicht gelöscht werden.',
					},
					toasts: {
						entryAdded: 'Eintrag hinzugefügt.',
						entryUpdated: 'Eintrag aktualisiert.',
						entryDeleted: 'Eintrag gelöscht.',
						saveFailed: 'Eintrag konnte nicht gespeichert werden.',
						deleteFailed: 'Eintrag konnte nicht gelöscht werden.',
					},
				},
				companies: {
					title: 'Lieferanten & Hersteller',
					description: 'In Inventargegenständen referenzierte Unternehmen werden hier verwaltet.',
					searchPlaceholder: 'Unternehmen durchsuchen…',
					buttons: {
						new: 'Neues Unternehmen',
					},
					empty: {
						text: 'Keine Unternehmen vorhanden. Lieferanten- und Herstellerinformationen werden nach dem Anlegen eines Eintrags gepflegt.',
						cta: 'Erstes Unternehmen hinzufügen',
					},
					card: {
						noName: 'Kein Name',
						noLocation: 'Kein Standort angegeben',
						unknownType: 'unbekannt',
						noAddress: 'Keine Adresse hinterlegt',
						usage: '{count} verknüpfter Gegenstand | {count} verknüpfte Gegenstände',
						editHint: 'Bearbeitung per Klick möglich →',
					},
					toasts: {
						companyAdded: 'Unternehmen hinzugefügt',
						companyUpdated: 'Unternehmen aktualisiert',
						companyDeleted: 'Unternehmen gelöscht',
						saveFailed: 'Unternehmen konnte nicht gespeichert werden',
						deleteFailed: 'Unternehmen konnte nicht gelöscht werden',
					},
				},
				companyModal: {
					title: {
						add: 'Unternehmen hinzufügen',
						edit: 'Unternehmen bearbeiten',
					},
					labels: {
						name: 'Name',
						postal: 'PLZ',
						city: 'Ort',
						address: 'Adresse',
						comment: 'Notiz',
						type: 'Typ',
					},
					placeholders: {
						name: 'Unternehmensname',
						postal: 'PLZ',
						city: 'Ort',
						address: 'Adresse',
						comment: 'Notizen zum Unternehmen',
					},
					type: {
						manufacturer: 'Hersteller',
						supplier: 'Lieferant',
						both: 'Beides',
					},
					delete: {
						title: 'Unternehmen löschen',
						text: 'Soll dieses Unternehmen gelöscht werden?',
						button: 'Unternehmen löschen',
					},
					buttons: {
						cancel: 'Abbrechen',
						add: 'Unternehmen hinzufügen',
						update: 'Unternehmen aktualisieren',
					},
					errors: {
						invalidName: 'Bitte einen gültigen Unternehmensnamen eingeben',
					},
				},
				itemModal: {
					title: {
						add: 'Inventargegenstand hinzufügen',
						edit: 'Inventargegenstand bearbeiten',
					},
					sections: {
						general: 'Allgemein',
						assignments: 'Zuordnungen',
						dates: 'Termine',
						calibration: 'Kalibrierung & Kosten',
						additional: 'Zusätzliche Informationen',
					},
					sectionNotes: {
						assignments: 'Beziehungen',
						dates: 'Lebenszyklus',
						calibration: 'Compliance',
						additional: 'Notizen',
					},
					labels: {
						title: 'Titel *',
						titlePlaceholder: 'Titel',
						internalId: 'Interne ID *',
						internalIdPlaceholder: 'Interne ID',
						project: 'Projekt',
						noProject: 'Kein Projekt',
						inventoryNumber: 'Inventarnummer',
						inventoryNumberPlaceholder: 'Inventarnummer',
						serialNumber: 'Seriennummer',
						serialNumberPlaceholder: 'Seriennummer',
						manufacturer: 'Hersteller',
						noManufacturer: 'Kein Hersteller',
						supplier: 'Lieferant',
						noSupplier: 'Kein Lieferant',
						previewImage: 'Vorschaubild',
						noPreview: 'Keine Vorschau',
						status: 'Status',
						noStatus: 'Kein Status',
						storageLocation: 'Lagerort',
						noStorageLocation: 'Kein Lagerort',
						projectedFrom: 'Eingeplant von',
						projectedTo: 'Eingeplant bis',
						acquisitionDate: 'Anschaffungsdatum',
						commissioningDate: 'Inbetriebnahme',
						calibrationRequired: 'Kalibrierung erforderlich',
						calibrationDate: 'Kalibrierungsdatum',
						calibrationValidUntil: 'Kalibrierung gültig bis',
						bookingAccount: 'Buchungskonto',
						bookingAccountPlaceholder: 'Buchungsreferenz',
						grossPrice: 'Bruttopreis (€)',
						comments: 'Zusätzliche Hinweise',
						commentsPlaceholder: 'Notizen…',
					},
					buttons: {
						delete: 'Löschen',
						new: 'Neu',
						cancel: 'Abbrechen',
						confirm: 'Bestätigen',
					},
					delete: {
						title: 'Gegenstand löschen',
						text: 'Soll dieser Gegenstand gelöscht werden? Diese Aktion kann nicht rückgängig gemacht werden.',
					},
					toasts: {
						validationFailed: 'Titel und interne ID sind erforderlich.',
						itemAdded: 'Inventargegenstand hinzugefügt.',
						itemUpdated: 'Inventargegenstand aktualisiert.',
						saveFailed: 'Beim Speichern des Gegenstands ist ein Fehler aufgetreten.',
					},
				},
			},
		},
		en: {
			inventory: {
				tabs: {
					inventory: 'Inventory',
					metadata: 'Metadata',
					companies: 'Companies',
				},
				header: {
					title: 'Inventory & Assets & Equipment',
				},
				common: {
					cancel: 'Cancel',
					confirm: 'Confirm',
					delete: 'Delete',
					new: 'New',
					add: 'Add',
					update: 'Update',
					unknown: 'unknown',
					noData: 'No details',
				},
				list: {
					title: 'Inventory catalogue',
					badge: '{count} items',
					create: 'Create item',
					searchPlaceholder: 'Search inventory…',
					filters: {
						status: {
							all: 'All statuses',
						},
						project: {
							all: 'All projects',
							unassigned: 'Unassigned',
						},
						calibration: {
							all: 'Calibration · All',
							required: 'Calibration required',
							notRequired: 'No calibration needed',
						},
					},
					reset: 'Reset',
					table: {
						title: 'Title',
						inventoryNumber: 'Inventory #',
						serial: 'Serial',
						project: 'Project',
						status: 'Status',
						calibration: 'Calibration',
						modified: 'Modified',
					},
					empty: 'No inventory items found',
					row: {
						noTitle: 'No title',
						unassigned: 'Unassigned',
						noStatus: 'No status',
						calibration: {
							badgeRequired: 'Calibration required',
							pending: 'Calibration pending',
							validUntil: 'Valid until {date}',
							notRequired: 'Not required',
							noCalibration: 'No calibration needed',
						},
						noInventoryNumber: '—',
						noSerial: '—',
					},
				},
				meta: {
					title: 'Metadata catalogue',
					description: 'Statuses, classes, and storage locations used throughout the inventory.',
					searchPlaceholder: 'Filter metadata entries…',
					sections: {
						status: 'Status',
						class: 'Classes',
						storageLocation: 'Storage locations',
					},
					buttons: {
						add: 'Add',
						edit: 'Edit',
					},
					empty: 'No entries yet',
					usage: '{count} linked item | {count} linked items',
					toasts: {
						entryCreated: 'Entry created',
						entryUpdated: 'Entry updated',
						entryDeleted: 'Entry deleted',
						saveFailed: 'Failed to save entry',
						deleteFailed: 'Failed to delete entry',
					},
				},
				metaModal: {
					title: {
						add: 'Add {label}',
						edit: 'Edit {label}',
					},
					labels: {
						name: 'Name',
					},
					placeholders: {
						name: 'Entry name',
					},
					delete: {
						title: 'Delete entry',
						text: 'Should this entry be deleted?',
						button: 'Delete entry',
					},
					buttons: {
						cancel: 'Cancel',
						add: 'Add {label}',
						update: 'Update {label}',
					},
					errors: {
						invalidName: 'A valid name is required.',
						cannotDelete: 'Cannot delete entry.',
					},
					toasts: {
						entryAdded: 'Entry added.',
						entryUpdated: 'Entry updated.',
						entryDeleted: 'Entry deleted.',
						saveFailed: 'Failed to save entry.',
						deleteFailed: 'Failed to delete entry.',
					},
				},
				companies: {
					title: 'Suppliers & Manufacturers',
					description: 'Companies referenced across inventory items are managed here.',
					searchPlaceholder: 'Search companies…',
					buttons: {
						new: 'New company',
					},
					empty: {
						text: 'No companies available. Supplier and manufacturer information is recorded once an entry is created.',
						cta: 'Create first company entry',
					},
					card: {
						noName: 'No name',
						noLocation: 'No location specified',
						unknownType: 'unknown',
						noAddress: 'No address provided',
						usage: '{count} linked item | {count} linked items',
						editHint: 'Editing is available via click →',
					},
					toasts: {
						companyAdded: 'Company added',
						companyUpdated: 'Company updated',
						companyDeleted: 'Company deleted',
						saveFailed: 'Failed to save company',
						deleteFailed: 'Failed to delete company',
					},
				},
				companyModal: {
					title: {
						add: 'Add company',
						edit: 'Edit company',
					},
					labels: {
						name: 'Name',
						postal: 'Postal',
						city: 'City',
						address: 'Address',
						comment: 'Comment',
						type: 'Type',
					},
					placeholders: {
						name: 'Company name',
						postal: 'Postal code',
						city: 'City',
						address: 'Address',
						comment: 'Notes about the company',
					},
					type: {
						manufacturer: 'Manufacturer',
						supplier: 'Supplier',
						both: 'Both',
					},
					delete: {
						title: 'Delete company',
						text: 'Should this company be deleted?',
						button: 'Delete company',
					},
					buttons: {
						cancel: 'Cancel',
						add: 'Add company',
						update: 'Update company',
					},
					errors: {
						invalidName: 'A valid company name is required.',
					},
				},
				itemModal: {
					title: {
						add: 'Add inventory item',
						edit: 'Edit inventory item',
					},
					sections: {
						general: 'General',
						assignments: 'Assignments',
						dates: 'Dates',
						calibration: 'Calibration & costs',
						additional: 'Additional information',
					},
					sectionNotes: {
						assignments: 'Relationships',
						dates: 'Lifecycle',
						calibration: 'Compliance',
						additional: 'Notes',
					},
					labels: {
						title: 'Title *',
						titlePlaceholder: 'Title',
						internalId: 'Internal ID *',
						internalIdPlaceholder: 'Internal ID',
						project: 'Project',
						noProject: 'No project',
						inventoryNumber: 'Inventory number',
						inventoryNumberPlaceholder: 'Inventory number',
						serialNumber: 'Serial number',
						serialNumberPlaceholder: 'Serial number',
						manufacturer: 'Manufacturer',
						noManufacturer: 'No manufacturer',
						supplier: 'Supplier',
						noSupplier: 'No supplier',
						previewImage: 'Preview image',
						noPreview: 'No preview',
						status: 'Status',
						noStatus: 'No status',
						storageLocation: 'Storage location',
						noStorageLocation: 'No storage location',
						projectedFrom: 'Projected from',
						projectedTo: 'Projected to',
						acquisitionDate: 'Acquisition date',
						commissioningDate: 'Commissioning date',
						calibrationRequired: 'Calibration required',
						calibrationDate: 'Calibration date',
						calibrationValidUntil: 'Calibration valid until',
						bookingAccount: 'Booking account',
						bookingAccountPlaceholder: 'Booking reference',
						grossPrice: 'Gross price (€)',
						comments: 'Additional notes',
						commentsPlaceholder: 'Notes…',
					},
					buttons: {
						delete: 'Delete',
						new: 'New',
						cancel: 'Cancel',
						confirm: 'Confirm',
					},
					delete: {
						title: 'Delete item',
						text: 'Should this item be deleted? This action cannot be undone.',
					},
					toasts: {
						validationFailed: 'Title and Internal ID are required.',
						itemAdded: 'Inventory item added.',
						itemUpdated: 'Inventory item updated.',
						saveFailed: 'An error occurred while saving the item.',
					},
				},
			},
		},
	},
}
